export default __webpack_public_path__ + "static/media/icon-back-dark.fed0356d.svg";